import React, {useState} from 'react';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import ReCAPTCHA from "react-google-recaptcha";


function row(other){
return (<tr key={other.uid}>
              <td>{other.username}</td>
              <td><Button role="link" className="login-btn" variant="info" href={`/user/premium/compare/${other.uid}`}>View Report</Button></td>
              </tr>);
}

function comparaisons(props){
  if (props.profileSharedWith && props.profileSharedWith.length >0) {  
  return (
    <div>
    <Card>
            <Card.Body>
          <h1>These profiles are shared with you</h1><br />
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>See comparison</th>
              </tr>
            </thead>
            <tbody>
              {props.profileSharedWith.map(other => {
                return row(other);
              })}
            </tbody>
        </Table>
          </Card.Body>
        </Card>
        <br />
        </div>
        );
  }else{
    return (<div></div>);
  }
}

function CompareProfile(props ) {

  const [done , setDone] = useState(false);
  const [doing, setDoing]  = useState(false)
  const [captcha, setCaptcha] = useState(null);
  const [email, setEmail] = useState(null);
  const [from, setFrom] = useState(null);
  const [error, setError]  = useState(false);

    const handleClick = event => {
      setDoing(true)

      if (!captcha) {
        alert("please complete the captcha first");
      }
      else{
        if (!email) {
        alert("please type in an email");
        }else{
        if(!from){
          setFrom(props.username);
        }
          fetch('https://9ap0wh9yya.execute-api.eu-central-1.amazonaws.com/compare-profile-request', {
        method : 'POST',
        body : JSON.stringify({captcha: captcha, email:email, from:from?from:props.username,respondTo:props.userEmail}),
        headers: {
        'Authorization': `Bearer ${props.jwt}`,
      }
  }).then(response => {
    if(response.status == 200){
      setDone(true);
      let res = response.json();
      return res;
    }else{
      setError(true);
    }
  });
          
        }
      }
      //post invite with name
      setDoing(false);
    }
    const captchaHandler = value => setCaptcha(value);
    const emailHandler = event => setEmail(event.target.value);
    const fromHandler = event => setFrom(event.target.value);
    if (props.quiz.length > 0) {
      if(error){
        return (
          <Alert  variant="danger">
            There was an error trying to send to {email}, please try again in a short while
          </Alert>
          
          )
      }
      if(done){
        return (
          <Alert  variant="success">
            Your invitation has been sent to {email} !
          </Alert>
          );
      }else{
    return (
        <div>
                <br /><br /><br />

                {comparaisons(props)}
                <h1>Invite someone to compare </h1>
                <p className="compareP">Please enter the email address for the person you'd like to compare your profile with.<br /></p>
                
                <div className="notabene">
                <b>Once that person complets the quiz and accepts your invitation, we'll notify both of you via email and your comparaison report will be available for both of you to read.</b>
                </div>

                <div className="form-group">
                  <label htmlFor="from"><p className="compareP">What sender name would you like us to display ?</p></label>
                  <p className="compareP">(We recommend using your full name as your sender name)</p>
                  <input id="from" placeholder={props.username} onChange={fromHandler}/>
                  <br /><br />

                  <label htmlFor="email" className="mr-2">Recipient email address :  </label> <br />
                  <input className="" placeholder="Enter email" onChange={emailHandler} /> <br />

                  <div className="captcha">
                    <ReCAPTCHA  sitekey="6Lemvr8ZAAAAAJHcZhhBSQIvBktYmpOua9DHte8u" onChange={captchaHandler}/>
                  </div>
                  <Button className="login-btn" role="link" onClick={handleClick}
                          disabled={doing}
                  >{!doing?"Send invite":"sending..."}</Button>
                </div>
                <br />
                <p className="compareP"><b>MyOceanity respects your privacy and will not store or use the email you entered once the invitation has been sent.</b></p>
                <br /><br /><br />

        </div>
      );
    }
  }else{
    return (
      <div><br /><br /><br /><p>You need to <a className="intlink" href="/user/premium/my-assessments">complete an assessment</a> before you can invite others.</p></div>
        )
  }


  }
export default CompareProfile;